<template>
	<div id="app" :class="{ noscroll: isActive }" scroll="no">
		<div v-if="authenticated" class="wrapper">
			<nav id="sidebar" :class="{ sidebaractive: isActive }">
				<div
					class="sidebar-header"
					style="display: flex; flex-direction: row; justify-content: center;"
				>
					<span class="that-ico"> </span>
				</div>

				<ul class="list-unstyled components">
					<li
						v-for="(module, moduleIndex) of newModules"
						:key="moduleIndex"
						:class="{ active: module.active }"
						@click="setActive(moduleIndex)"
					>
						<div class="sidebar-link">{{ module.text }}</div>
					</li>
					<li class="logout-row">
						<button
							class="btn btn-secondary logout-butt"
							@click="logout"
						>
							Odhlásit
						</button>
					</li>
					<li class="chyba-row">
						<button
							class="btn btn-warning logout-butt"
							@click="showModal"
						>
							Ticket
						</button>
					</li>
				</ul>
			</nav>
			<div
				class="container-fluid p-0 "
				style="min-height: 100vh; background-color: #e0ecff;"
				v-if="!isActive"
			>
				<div class="tgb-row" style="background-color: #4CA5F9;">
					<button
						type="button"
						id="sidebarCollapse"
						class="btn my-btn"
						@click="isActive = !isActive"
						style="display:flex; flex-direction: row; margin-right: auto;"
					>
						<span class="menu-ico"> </span>
					</button>
				</div>

				<router-view
					@wtf="wtf"
					@newUserPowers="newUserPowers"
					:userName="user"
					:userPowers="userPowers"
				/>
			</div>
		</div>
		<div
			v-else
			class="wrapper"
			style="height: 100vh; background-color: #e0ecff;"
		>
			<div class="container-fluid">
				<div class="row">
					<div class="col">
						<img
							class="logo-img"
							src="./assets/nejLogo.svg"
							alt="Nej logo"
						/>
					</div>
				</div>
				<div
					class="row"
					style="display: flex; flex-direction: row; justify-content: center;"
				>
					<div class="col col-md-6 col-lg-4 col-xl-3 mt-5 text-left">
						Uživatelské jméno:
					</div>
				</div>

				<div
					class="row mt-2"
					style="display: flex; flex-direction: row; justify-content: center;"
				>
					<div class="col col-md-6 col-lg-4 col-xl-3">
						<input
							class="form-control "
							v-model="userName"
							placeholder="Uživ. jméno"
						/>
					</div>
				</div>

				<div
					class="row mt-4"
					style="display: flex; flex-direction: row; justify-content: center;"
				>
					<div class="col col-md-6 col-lg-4 col-xl-3 text-left">
						Heslo:
					</div>
				</div>

				<div
					class="row mt-2"
					style="display: flex; flex-direction: row; justify-content: center;"
				>
					<div class="col col-md-6 col-lg-4 col-xl-3">
						<input
							class="form-control"
							v-model="userPassword"
							v-on:keyup.enter="loginUser"
							type="password"
							placeholder="Heslo"
							autocomplete="off"
						/>
					</div>
				</div>
				<div
					class="row mt-4"
					style="display: flex; flex-direction: row; justify-content: center;"
				>
					<div class="col col-md-6 col-lg-4 col-xl-3">
						<button
							class="btn btn-info"
							style="width: 100%;"
							@click="loginUser"
						>
							Přihlásit
						</button>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="modal-ticket"
			title="Vytvořit ticket"
			:size="'lg'"
			@hidden="resetModal"
		>
			<template #modal-title>
				Vytvořit ticket o chybě.
			</template>
			<div class="d-block text-center">
				<div class="row">
					<textarea
						type="textarea"
						class="form-control col-9 ml-2"
						rows="5"
						id="ruian"
						placeholder="Popište chybu"
						v-model="displayText"
					></textarea>
				</div>
			</div>
			<template #modal-footer>
				<div class="row">
					<button
						class="btn btn-secondary px-3 py-2 mr-2"
						@click="closeModal"
					>
						Zrušit
					</button>
					<button
						class="btn btn-primary px-3 py-2 mr-2"
						@click="createTicket"
					>
						Odeslat
					</button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import AdditionsService from "@/services/AdditionsService";
import { mapActions, mapGetters } from "vuex";
import modal from "@/components/modal.vue";

export default {
	name: "App",

	data() {
		const u = localStorage.getItem("user");
		return {
			authenticated: false,
			modules: [
				{
					text: "Home",
					active: false,
					viewName: "CatchPhrase",
					needs: "home",
					icon: "house.png"
				},
				{
					text: "Vyhledávač",
					active: false,
					viewName: "SearchProviderView",
					needs: "search-provider"
				},
				{
					text: "Editor",
					active: true,
					viewName: "VerifierView",
					needs: "overovac"
				},
				{
					text: "Users",
					active: false,
					viewName: "UsersView",
					needs: "users"
				},
				{
					text: "Správa",
					active: false,
					viewName: "ManageView",
					needs: "database"
				},
				{
					text: "Mapa",
					active: false,
					viewName: "MapView",
					needs: "database"
				},
				{
					text: "Upgrade",
					active: false,
					viewName: "UpgradeView",
					needs: "upgrade"
				},
				{ text: "" }
			],
			newModules: [],
			userName: null,
			userPassword: null,
			userPowers: [],
			user: u,
			isActive: false,
			displayText: ""
		};
	},

	async mounted() {
		const powers = localStorage.getItem("powers");
		const authenticatedMy = localStorage.getItem("authenticated");
		const userObj = localStorage.getItem("userObject");
		if (authenticatedMy === "false") {
			this.authenticated = false;
		} else {
			// } else if (authenticatedMy === 'true'){
			// if (userObj.id) {
			this.authenticated = true;
			// }
		}

		for (const o of this.modules) {
			if (o.viewName === this.$router.currentRoute.name) {
				o.active = true;
			} else {
				o.active = false;
			}
		}

		const userObjParsed = JSON.parse(userObj);
		let checkAuth;
		try {
			checkAuth = await AdditionsService.authenticateUser(
				userObjParsed.name
			);
		} catch (e) {
			this.authenticated = false;
			this.logoutAction();
			return;
		}

		if (!checkAuth.data.passed) {
			this.authenticated = false;
			this.logoutAction();
		}

		if (powers) {
			this.userPowers = powers.split(",");
		}

		if (
			checkAuth.data.passed &&
			powers !== checkAuth.data.powers.join(",")
		) {
			this.userPowers = checkAuth.data.powers;
		}

		// const holdModules = [...this.modules]
		const newModules = [];

		for (const o of this.modules) {
			if (this.userPowers.includes(o.needs)) {
				newModules.push(o);
			}
		}

		this.newModules = newModules;
		this.setActive(0);
	},

	computed: {
		...mapGetters(["getAuthenticated"])
	},

	methods: {
		...mapActions([
			"loginAction",
			"logoutAction",
			"getMail",
			"refreshUserAction"
		]),

		resetModal() {},

		async createTicket() {
			const userObj = localStorage.getItem("userObject");
			const userObjParsed = JSON.parse(userObj);
			await AdditionsService.createTicket(
				userObjParsed.name,
				this.displayText
			);
			this.displayText = "";
			this.$bvModal.hide("modal-ticket");
		},

		showModal() {
			this.isActive = false;
			this.$bvModal.show("modal-ticket");
		},

		closeModal() {
			this.displayText = "";
			this.$bvModal.hide("modal-ticket");
		},

		async checkAuthOnRoute() {
			const userObj = localStorage.getItem("userObject");
			const userObjParsed = JSON.parse(userObj);
			let checkAuth;
			try {
				checkAuth = await AdditionsService.authenticateUser(
					userObjParsed.name
				);
			} catch (e) {
				this.authenticated = false;
				this.logoutAction();
				return;
			}
			if (!checkAuth.data.passed) {
				this.authenticated = false;
				this.logoutAction();
			}
		},

		wtf(au) {
			this.authenticated = au;
			if (!this.authenticated) {
				this.logoutAction();
			}
		},

		async loginUser() {
			const test = await this.loginAction({
				userName: this.userName,
				password: this.userPassword
			});
			if (test) {
				this.userPowers = test;
				this.authenticated = true;
			}

			this.userName = null;
			this.userPassword = null;

			const newModules = [];

			for (const o of this.modules) {
				if (this.userPowers.includes(o.needs)) {
					newModules.push(o);
				}
			}

			this.newModules = newModules;
			this.setActive(0);
		},

		newUserPowers(powers) {
			this.userPowers = powers;
			localStorage.setItem("powers", powers);
		},

		logout() {
			this.authenticated = false;
			this.logoutAction();
		},

		setActive(index) {
			const needs = this.newModules[index].needs;
			if (!this.userPowers || !this.userPowers.includes(needs)) {
				for (const m of this.newModules) {
					m.active = false;
				}
				this.$router.replace({ name: "noAccess" });
				return;
			}

			this.modules[index].active = true;
			for (let i = 0; i < this.newModules.length; i++) {
				if (parseInt(i) === parseInt(index)) {
					this.newModules[i].active = true;
				} else {
					this.newModules[i].active = false;
				}
			}
			this.$router.replace({ name: this.newModules[index].viewName });
			this.isActive = false;
		}
	},

	watch: {
		$route(to, from) {
			document.title = to.meta.title || "Your Website";
			this.checkAuthOnRoute();
		}
	}
};
</script>

<style>
.login-hold {
	background-color: #e0ecff;
	height: 100vh;
}

.logout-row {
	position: absolute;
	bottom: 15px;
	display: flex;
	flex-direction: row;
	margin-left: 15px;
}
.chyba-row {
	position: absolute;
	bottom: 60px;
	display: flex;
	flex-direction: row;
	margin-left: 15px;
}

.logo-img {
	width: 300px;
	height: 150px;
}

.wrapper {
	display: flex;
	width: 100%;
	align-items: stretch;
}

/*
    ADDITIONAL DEMO STYLE, NOT IMPORTANT TO MAKE THINGS WORK BUT TO MAKE IT A BIT NICER :)
*/
@import "https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700";

body {
	font-family: "Poppins", sans-serif;
	background: #fafafa;
}

p {
	font-family: "Poppins", sans-serif;
	font-size: 1.1em;
	font-weight: 300;
	line-height: 1.7em;
	color: #999;
}

.sidebar-link,
.sidebar-link:hover,
.sidebar-link:focus {
	color: inherit;
	text-decoration: none;
	transition: all 0.3s;
}

#sidebar {
	width: 250px;
	min-height: 100vh;
	background-color: #4ca5f9;

	color: #fff;
	transition: all 0.3s;
}

#sidebar .sidebar-header {
	background-color: white;
	height: 54px;
	font-size: 26px;
	color: gray;
	border-bottom: 1px solid rgba(199, 197, 197, 0.472);
	display: flex;
	flex-direction: row;
}

.midbar-header {
	display: flex;
	flex-direction: row;
}

#sidebar ul.components {
	padding: 20px 0;
}

#sidebar ul p {
	color: #fff;
	padding: 10px;
}

#sidebar ul li div {
	padding: 10px;
	font-size: 1.1em;
	display: block;
	cursor: pointer;
}
#sidebar ul li div:hover {
	color: #7386d5;
	background: #fff;
}

#sidebar ul li.active > div,
div[aria-expanded="true"] {
	color: #fff;
	background-color: rgb(31, 142, 246);
}
ul ul div {
	font-size: 0.9em !important;
	padding-left: 30px !important;
	background: #6d7fcc;
}

.sidebaractive {
	margin-left: 0px;
}

.menu-ico {
	background-image: url("./assets/menu.svg");
	width: 30px;
	height: 30px;
	background-position: no-repeat;
	background-size: cover;
}

.toggle-button {
	margin-left: -1000px;
}

.tgb-row {
	display: none;
}

@media (max-width: 768px) {
	#sidebar {
		position: absolute;
		margin-left: -100vw;
		width: 100vw;
		z-index: 100000;
	}

	.logout-row {
		width: 100%;
		bottom: 50px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-left: 0px;
	}

	.chyba-row {
		width: 100%;
		bottom: 100px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-left: 0px;
	}

	.sidebaractive {
		margin-left: 0 !important;
	}

	.toggle-button {
		margin-left: 0px;
	}

	.tgb-row {
		display: flex;
		flex-direction: row;
		line-height: 42px;
		font-size: 18px;
	}
}

.hidethis {
	display: none;
}

.noscroll {
	overflow: hidden;
}

.fadein {
	animation: fadeIn ease 4s;
	-webkit-animation: fadeIn ease 4s;
	-moz-animation: fadeIn ease 4s;
	-o-animation: fadeIn ease 4s;
	-ms-animation: fadeIn ease 4s;
}
@keyframes fadeIn {
	0% {
		opacity: 0;
	}

	75% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

@-moz-keyframes fadeIn {
	0% {
		opacity: 0;
	}
	75% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

@-webkit-keyframes fadeIn {
	0% {
		opacity: 0;
	}
	75% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

@-o-keyframes fadeIn {
	0% {
		opacity: 0;
	}
	75% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

@-ms-keyframes fadeIn {
	0% {
		opacity: 0;
	}
	75% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

.header {
	position: fixed;
	width: 100%;
	height: 45px;
	background-color: #4ca5f9;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.header-logout-mobile {
	line-height: 45px;
	padding-right: 5px;
}

.header-logout {
	margin-left: auto;
	line-height: 45px;
	padding-right: 5px;
}

.logout-border {
	background-color: rgba(71, 71, 71, 0.417);
	color: white;
	font-size: 16px;
	font-weight: bold;
	padding: 8px;
	border-radius: 15px;
}

.menu {
	position: fixed;
	width: 200px;
	height: 100%;
	background-color: #4ca5f9;

	display: flex;
	flex-direction: column;
	text-align: left;

	color: rgba(255, 250, 250, 0.904);
	border-right: 2px solid rgba(199, 197, 197, 0.472);
}

.that-ico {
	background-image: url("./assets/nejLogo.svg");
	width: 86px;
	height: 54px;
	background-position: no-repeat;
	background-size: cover;
}

.dodatek {
	color: rgb(71, 71, 71);
	font-size: 14px;
	font-weight: bold;
	margin-left: 5px;
}

.menu-item {
	height: 45px;
	border-bottom: 1px solid rgba(199, 197, 197, 0.472);
	line-height: 45px;
	font-size: 18px;
	padding-left: 10px;
	cursor: pointer;
}

.login {
	height: 300px;
	display: flex;
	flex-direction: column;
}

.login-input {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 10px;
}

.login-input-button {
	width: 175px;
	height: 25px;
	background-color: rgb(0, 204, 255);
	border: none;
}

.menu-mobile {
	display: none;
}

@media (max-width: 1000px) {
	.menu {
		display: none;
	}

	.header-logout {
		display: none;
	}

	.menu-mobile {
		display: block;
		height: 45px;
		text-align: center;
		line-height: 45px;
		font-size: 20px;
		z-index: 10000;
	}

	.menu-first {
		height: 30px;
		font-size: 26px;
		line-height: 30px;

		padding-left: 5px;
		background-color: white;
		color: gray;
		border-bottom: 2px solid rgba(199, 197, 197, 0.472);
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.that-ico {
		background-image: url("./assets/nejLogo.svg");
		width: 86px;
		height: 54px;
		background-position: no-repeat;
		background-size: cover;
	}

	.ico {
		display: block;
		height: 45px;
		width: 45px;
		background-position: no-repeat;
		background-size: cover;
		cursor: pointer;
	}

	.menu-item {
		text-align: center;
		line-height: 40px;
		height: 45px;
		border-bottom: 1px solid rgba(199, 197, 197, 0.472);
		font-size: 18px;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue